
import React from "react";
import { CheckCircle } from "lucide-react";

const ReviewStep = ({ installationData, formatDate }) => {
  return (
    <div className="space-y-8">
      <div className="text-center">
        <CheckCircle className="w-16 h-16 text-emerald-600 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Review & Confirm
        </h2>
        <p className="text-gray-600">
          Please review all details before confirming
        </p>
      </div>

      {/* Review Summary */}
      <div className="space-y-6">
        <div className="bg-gray-50 rounded-2xl p-6">
          <h3 className="font-semibold text-gray-900 mb-4">
            Installation Schedule
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <span className="font-medium">Preferred Date:</span>{" "}
              {formatDate(installationData.preferredDate)}
            </div>
            <div>
              <span className="font-medium">Preferred Time:</span>{" "}
              {installationData.preferredTime}
            </div>
            {installationData.alternateDate && (
              <div>
                <span className="font-medium">Backup Date:</span>{" "}
                {formatDate(installationData.alternateDate)}
              </div>
            )}
            {installationData.alternateTime && (
              <div>
                <span className="font-medium">Backup Time:</span>{" "}
                {installationData.alternateTime}
              </div>
            )}
            <div>
              <span className="font-medium">Contact Method:</span>{" "}
              {installationData.contactMethod}
            </div>
            <div>
              <span className="font-medium">Payment Method:</span>{" "}
              {installationData.paymentMethod.replace("-", " ")}
            </div>
          </div>
        </div>

        {installationData.specialInstructions && (
          <div className="bg-gray-50 rounded-2xl p-6">
            <h3 className="font-semibold text-gray-900 mb-4">
              Special Instructions
            </h3>
            <p className="text-gray-600">
              {installationData.specialInstructions}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewStep;
